import { default as axios } from '../utils/axios.instances' // eslint-disable-line

const axiosInstance = axios.getSTAxios() // eslint-disable-line

export default {

  async createCustomer (options) {
    return new Promise((resolve, reject) => {
      axiosInstance
        .post('integrations/paddle-billing/customer/create/', options)
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  async updateCustomer (options) {
    return new Promise((resolve, reject) => {
      axiosInstance
        .post('integrations/paddle-billing/customer/update/', options)
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  async loadCustomer () {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get('integrations/paddle-billing/customer/')
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  async getUpgradePricesPreview (options) {
    return new Promise((resolve, reject) => {
      axiosInstance
        .post('integrations/paddle-billing/upgrade/preview/', { price_id: options.priceId })
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  async getSubscription () {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get('integrations/paddle-billing/subscription/')
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  async updateAddress (address) {
    return new Promise((resolve, reject) => {
      axiosInstance
        .post('integrations/paddle-billing/customer/update-address/', address)
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  async updateBusiness (business) {
    return new Promise((resolve, reject) => {
      axiosInstance
        .post('integrations/paddle-billing/customer/update-business/', business)
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  async updateSubscriptionBusiness (businessId) {
    return new Promise((resolve, reject) => {
      axiosInstance
        .post('integrations/paddle-billing/subscription/update/', { business_id: businessId })
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  async requestInvoice (options) {
    return new Promise((resolve, reject) => {
      axiosInstance
        .post('integrations/paddle-billing/customer/wire-transfer-invoice/', options)
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}
